"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SubaccountSetPasswordOverview = exports.SubaccountSetPassword = exports.passwordValidate = exports.PASSWORD_REGEX = void 0;

var Yup = _interopRequireWildcard(require("yup"));

var _react = _interopRequireWildcard(require("react"));

var _i18next = _interopRequireDefault(require("i18next"));

var _formik = require("formik");

var _reactI18next = require("react-i18next");

var _Fade = _interopRequireDefault(require("@material-ui/core/Fade"));

var _CreatePasswordFields = _interopRequireDefault(require("../CreatePasswordFields"));

var _HeroHeader = _interopRequireDefault(require("../HeroHeader"));

var _HeroFooter = _interopRequireDefault(require("../HeroFooter"));

var _FormLabel = _interopRequireDefault(require("../FormLabel"));

var _Header = _interopRequireDefault(require("./Header"));

var _ButtonGroup = _interopRequireDefault(require("./ButtonGroup"));

/* eslint-disable no-useless-escape */
var PASSWORD_REGEX = /^[a-z0-9!"#$%&'()*+,.\/\\:;<=>?@\[\]^_`{|}~-]*$/i;
exports.PASSWORD_REGEX = PASSWORD_REGEX;
var passwordValidate = {
  password: Yup.string().matches(PASSWORD_REGEX, _i18next["default"].t('signup.form.password.invalidCharacters')).min(6, _i18next["default"].t('signup.form.password.length')).max(128, _i18next["default"].t('signup.form.password.length')).required(_i18next["default"].t('required')),
  confirmPassword: Yup.mixed().required(_i18next["default"].t('signup.form.confirmPassword.match')).oneOf([Yup.ref('password'), null], _i18next["default"].t('signup.form.confirmPassword.match'))
};
exports.passwordValidate = passwordValidate;

var SetPassword = function SetPassword(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var pwdOnchange = props.pwdOnchange,
      repeatPwdOnchange = props.repeatPwdOnchange,
      reportEvent = props.reportEvent;
  (0, _react.useEffect)(function () {
    if (reportEvent) {
      reportEvent();
    }
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    id: "passwordForm",
    onSubmit: function onSubmit(v) {
      return props.onSubmit(v.password);
    },
    initialValues: {
      password: '',
      confirmPassword: ''
    },
    validationSchema: Yup.object().shape(passwordValidate)
  }, function (_ref) {
    var errors = _ref.errors,
        touched = _ref.touched,
        values = _ref.values,
        isValid = _ref.isValid;
    return /*#__PURE__*/_react["default"].createElement(_Fade["default"], {
      "in": true
    }, /*#__PURE__*/_react["default"].createElement(_formik.Form, {
      className: "w-full min-h-full flex flex-col justify-between"
    }, props.back, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex-grow flex flex-col justify-center px-3 pb-10 md:pb-0"
    }, /*#__PURE__*/_react["default"].createElement(_Header["default"], {
      className: "mb-3"
    }, t('signup.form.password.header')), props.email && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], null, t('signup.subaccount.password.email')), /*#__PURE__*/_react["default"].createElement("h3", {
      className: "text-primary font-bold text-2xl mb-8"
    }, props.email)), /*#__PURE__*/_react["default"].createElement(_CreatePasswordFields["default"], {
      repeatPwdOnchange: repeatPwdOnchange,
      pwdOnchange: pwdOnchange,
      visibleToggle: true
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "fixed bottom-0 w-full shadow-hover md:static md:px-3 md:shadow-none"
    }, /*#__PURE__*/_react["default"].createElement(_ButtonGroup["default"], {
      onBack: props.onBack,
      isValid: isValid
    }))));
  });
};

var SubaccountSetPasswordOverview = function SubaccountSetPasswordOverview(_ref2) {
  var domain = _ref2.domain;

  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation2.t;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col items-center justify-between h-full"
  }, /*#__PURE__*/_react["default"].createElement(_HeroHeader["default"], {
    title: t('signup.subaccount.title', {
      domain: domain
    }),
    subtitle: /*#__PURE__*/_react["default"].createElement("p", {
      className: "text-white text-sm flex items-center opacity-50 mt-5"
    }, t('signup.subaccount.subtitle'))
  }), /*#__PURE__*/_react["default"].createElement(_HeroFooter["default"], {
    className: "mb-5"
  }));
};

exports.SubaccountSetPasswordOverview = SubaccountSetPasswordOverview;

var SubaccountSetPassword = function SubaccountSetPassword(props) {
  var _useTranslation3 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation3.t;

  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    id: "passwordForm",
    onSubmit: function onSubmit(v) {
      return props.onSubmit(v.password);
    },
    initialValues: {
      password: '',
      confirmPassword: ''
    },
    validationSchema: Yup.object().shape(passwordValidate)
  }, function (_ref3) {
    var errors = _ref3.errors,
        touched = _ref3.touched,
        values = _ref3.values,
        isValid = _ref3.isValid;
    return /*#__PURE__*/_react["default"].createElement(_formik.Form, {
      className: "w-full h-full flex flex-col justify-between"
    }, /*#__PURE__*/_react["default"].createElement(_Fade["default"], {
      "in": true
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex-grow flex flex-col justify-center px-3"
    }, /*#__PURE__*/_react["default"].createElement(_Header["default"], null, t('signup.subaccount.password.title')), /*#__PURE__*/_react["default"].createElement("p", {
      className: "font-bold text-light mb-8"
    }, t('signup.subaccount.password.subtitle')), props.email && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], null, t('signup.subaccount.password.email')), /*#__PURE__*/_react["default"].createElement("h3", {
      className: "text-primary font-bold text-2xl mb-8"
    }, props.email)), /*#__PURE__*/_react["default"].createElement(_CreatePasswordFields["default"], {
      visibleToggle: true
    }))), /*#__PURE__*/_react["default"].createElement(_ButtonGroup["default"], {
      onBack: props.onBack,
      isValid: isValid
    }));
  });
};

exports.SubaccountSetPassword = SubaccountSetPassword;
var _default = SetPassword;
exports["default"] = _default;
//# sourceMappingURL=SetPassword.js.map